// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_gk-6";
export var emphasizeQuantity = "_gk-3";
export var flatBottomCorners = "_gk-5";
export var productImage = "_gk-0";
export var quantityContainer = "_gk-2";
export var tooltip = "_gk-1";
export var wrapAndEllipsesOverflow = "_gk-4";